import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from 'antd'
import { useSelector } from 'react-redux'

import { ColorsPalette } from '../../config/colors'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'

const TooltipIcon = ({ color = ColorsPalette.SECOND, icon = faInfoCircle, title }) => {
  const t = useSelector(selectTranslate)

  return (
    <Tooltip title={t(title)}>
      <FontAwesomeIcon icon={icon} color={color} />
    </Tooltip>
  )
}

export default TooltipIcon
